//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "SNSS",
  data() {
    return {
      form: {
        value1: "",
        value2: "",
        value3: "",
        value4: "",
        value5: "",
        value6: "",
        value7: "",
        value8: "",
        value9: "",
      },
      hasScore: false,
      disabled: false,
      dataList: [
        { value: "6", name: "清醒" },
        { value: "4", name: "嗜睡" },
        { value: "2", name: "昏睡" },
        { value: "0", name: "昏迷" },
      ],
      dataList1: [
        { value: "6", name: "时间、人物及地点定向均正常" },
        { value: "4", name: "其中2项正常" },
        { value: "2", name: "其中1项正常" },
        { value: "0", name: "完全失定向" },
      ],
      dataList2: [
        { value: "10", name: "正常/无失语" },
        { value: "6", name: "词汇减少，言语不连贯" },
        { value: "3", name: "语句缩短" },
        { value: "0", name: "只能回答是否，语言极困难或完全不能" },
      ],
      dataList3: [
        { value: "4", name: "无凝视麻痹" },
        { value: "2", name: "凝视麻痹" },
        { value: "0", name: "同向偏斜" },
      ],
      dataList4: [
        { value: "2", name: "无/可疑/轻瘫" },
        { value: "0", name: "明显" },
      ],
      dataList5: [
        { value: "6", name: "正常，能上举" },
        { value: "5", name: "肌力减退，上举力弱" },
        { value: "4", name: "上举时肘部屈曲" },
        { value: "2", name: "不能抗重力" },
        { value: "0", name: "瘫痪" },
      ],
      dataList6: [
        { value: "6", name: "肌力活动正常" },
        { value: "4", name: "肌力减退" },
        { value: "2", name: "指不能对掌" },
        { value: "0", name: "瘫痪" },
      ],
      dataList7: [
        { value: "6", name: "正常，能抬腿" },
        { value: "5", name: "肌力减退，抬腿力弱" },
        { value: "4", name: "抬腿时膝部屈曲" },
        { value: "2", name: "不能抗重力" },
        { value: "0", name: "瘫痪" },
      ],
      dataList8: [
        { value: "12", name: "无支持下行走5m" },
        { value: "9", name: "支持下行走" },
        { value: "6", name: "在搀扶下行走" },
        { value: "3", name: "无支持下能坐" },
        { value: "0", name: "卧床/轮椅" },
      ],
      
     
      
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      let result = 0;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
        result += Number(form[key]);
      }
      if (!flag) {
        self.hasScore = false;
        return "";
      } else {
        self.hasScore = true;
        return String(result);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/SNSS.vue